import pointerIcon from '../../assets/icons/map/pinPlace1.svg';
import busMarkerLight from '../../assets/icons/map/busMarkerLight.svg';
import busMarkerDark from '../../assets/icons/map/busMarkerDark.svg';
import {themeOptions} from '../../utils/utils';
import {INFO_TIME_MARKER_HEIGHT, INFO_TIME_MARKER_WIDTH} from '../constants';
import {createWalkInfoPin} from './file.utils';

export const getLocationHalo = (): google.maps.Marker => new google.maps.Marker({
    icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 6,
        fillColor: '#497BDE',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2,
    },
});

// Función para generar los puntos de un círculo
function generateCirclePoints(center: google.maps.LatLng, radius: number, numPoints: number): google.maps.LatLng[] {
    const points: google.maps.LatLng[] = [];
    const earthRadius = 6371000; // Radio de la Tierra en metros

    for (let i = 0; i < numPoints; i++) {
        const angle = (i / numPoints) * 2 * Math.PI;
        const dx = radius * Math.cos(angle);
        const dy = radius * Math.sin(angle);

        const lat = center.lat() + (dy / earthRadius) * (180 / Math.PI);
        const lng = center.lng() + (dx / earthRadius) * (180 / Math.PI) / Math.cos(center.lat() * Math.PI / 180);

        points.push(new google.maps.LatLng(lat, lng));
    }

    return points;
}

export const getLocationShapes = (center: google.maps.LatLng): google.maps.Polyline[] => {
    const circles = [
        {radius: 2520, numPoints: 60},
        {radius: 840, numPoints: 60},
        {radius: 420, numPoints: 60},
    ];

    const polylines: google.maps.Polyline[] = [];

    circles.forEach((circle) => {
        const theme = localStorage.getItem('theme');

        const points = generateCirclePoints(center, circle.radius, circle.numPoints);
        const strokeColor = theme === themeOptions[0] ? '#000000' : '#FFFFFF';

        for (let i = 0; i < points.length; i++) {
            polylines.push(new google.maps.Polyline({
                path: [points[i], points[(i + 1) % points.length]],
                strokeColor: strokeColor,
                strokeOpacity: 0, // Opacidad del trazo para que no se vea el trazo sólido
                strokeWeight: 2,
                icons: [{
                    icon: {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 1,
                        scale: 2,
                    },
                    offset: '0',
                    repeat: '10px',
                }],
                clickable: false,
            }));
        }
    });

    return polylines;
};

export const getRealTimeMarker = (): google.maps.Marker => {
    const theme = localStorage.getItem('theme');
    const iconUrl = theme === 'theme-dark' ? busMarkerDark : busMarkerLight;

    return new google.maps.Marker({
        icon: {
            url: iconUrl,
            scaledSize: new google.maps.Size(26, 26),
        },
        optimized: true,
    });
};


export const getPointerMarker = (): google.maps.Marker => new google.maps.Marker({
    icon: {
        url: pointerIcon,
        scaledSize: new google.maps.Size(20, 26),
    },
    optimized: true,
});

export const getInfoTimeMarkers = async (): Promise<google.maps.Marker[]> => {
    const pin5 = await createWalkInfoPin(5) || '';
    const pin10 = await createWalkInfoPin(10) || '';
    const pin30 = await createWalkInfoPin(30) || '';

    return [
        new google.maps.Marker({
            icon: {
                url: pin5,
                scaledSize: new google.maps.Size(
                    INFO_TIME_MARKER_WIDTH,
                    INFO_TIME_MARKER_HEIGHT,
                ),
            },
            clickable: false,
        }),
        new google.maps.Marker({
            icon: {
                url: pin10,
                scaledSize: new google.maps.Size(
                    INFO_TIME_MARKER_WIDTH,
                    INFO_TIME_MARKER_HEIGHT,
                ),
            },
            clickable: false,
        }),
        new google.maps.Marker({
            icon: {
                url: pin30,
                scaledSize: new google.maps.Size(
                    INFO_TIME_MARKER_WIDTH,
                    INFO_TIME_MARKER_HEIGHT,
                ),
            },
            clickable: false,
        }),
    ];
};
